<template>
    <v-app id="inspire">
        <Header type="search-crm" />
        <v-main class="grey lighten-3">

            <v-container>
                <v-row>

                    <Menu />

                    <v-container class="col-11">
                        <v-row>
                            <v-col class="page-top d-flex justify-space-between" cols="12">
                                <div>
                                    <div class="page-title">Монитор продаж</div>
                                    <div class="breadcrumb">
                                        Монитор продаж
                                    </div>
                                </div>
                            </v-col>
                        </v-row>
                        <Grid :column="1" :gap="20">
                            <Block :withBorder="true" :padding="0">
                                <div class="filter">
                                    <div class="filter__field">
                                        <span>Структурная единица</span>
                                        <v-text-field
                                            :value="monitor ? monitor.monitor.club.name : null"
                                            outlined
                                            dense
                                            readonly
                                            style="height: 48px;margin-top: 10px; max-width: 250px; width: 250px"
                                            class="rounded-lg"
                                        ></v-text-field>
                                    </div>
                                    <div class="filter-date" style="margin-top: 25px; width: 270px;">
                                      <v-btn-toggle
                                          v-model="specialistType"
                                          mandatory
                                          background-color="#FFFFFF"
                                          class="rounded-lg"
                                          style="width: 100%"
                                      >
                                        <v-btn @click="setSpecialistType(false)">
                                          Все
                                        </v-btn>
                                        <v-btn @click="setSpecialistType(true)">
                                          Мои
                                        </v-btn>
                                        <v-btn>
                                          Сотрудник
                                        </v-btn>
                                      </v-btn-toggle>
                                    </div>
                                    <div class="filter__field" v-if="specialistType === 2">
                                        <span>Сотрудник</span>
                                        <v-select
                                          @change="setSpecialistTypeChange(false)"
                                            class="rounded-lg custom__select"
                                            v-model="specialist_id"
                                            :items="specialist ? specialist.specialist : []"
                                            item-value="id"
                                            item-text="name"
                                            :menu-props="{ bottom: true, offsetY: true, rounded: 'lg', maxWidth: '250' }"
                                            placeholder="Выбрать"
                                            append-icon="mdi-chevron-down"
                                            outlined
                                            dense
                                            style="height: 48px;margin-top: 10px; max-width: 250px; width: 250px">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="filter" style="justify-content: space-between;">
                                  <div style="display:flex;">
                                  <div class="filter-date">
                                    <v-btn-toggle
                                        v-model="dateType"
                                        mandatory
                                        background-color="#FFFFFF"
                                        class="rounded-lg"
                                        style="margin-top: 40px; width: 100%"
                                    >
                                      <v-btn width="25%" @click="setDateType(0)">
                                        Сегодня
                                      </v-btn>
                                      <v-btn width="25%" @click="setDateType(1)">
                                        Неделя
                                      </v-btn>
                                      <v-btn width="25%" @click="setDateType(2)">
                                        Месяц
                                      </v-btn>
                                      <v-btn width="25%" @click="setDateType(3)">
                                        На дату
                                      </v-btn>
                                    </v-btn-toggle>
                                  </div>
                                  
                                  <div class="ml-5">
                                    <!-- <VueDatePicker 
                            no-title
                            no-header 
                            v-model="date"
                                        v-show="dialogDate"
                            range
                            rangeInputText="%d - %d"
                            format="DD MMMM"
                            color="#629f34"
                            style="flex: none !important;">
                              <template #activator="{ date }">
                                <button class="custom__date-button" ref="activator"
                                        type="button">
                                  <v-icon dark small class="mr-2">
                                    mdi-calendar-blank-outline
                                  </v-icon>
                                  {{ date }}
                                </button>
                              </template>
                            </VueDatePicker> -->
                                    <VueDatePicker
                                        no-title
                                        no-header
                                        color="#629f34"
                                        v-model="date"
                                        v-show="dialogDate"
                                        range
                                        rangeInputText="%d - %d"
                                        format="DD MMMM"
                                        style="flex: none !important;"
                                    >
                                      <template #activator="{ date }">
                                        <button
                                            class="button custom__button"
                                            ref="activator"
                                            type="button"
                                        >
                                          <v-icon
                                              dark
                                              right
                                              small
                                              class="mr-2"
                                          >
                                            mdi-calendar-blank-outline
                                          </v-icon>  {{ date }}
                                        </button>
                                      </template>
                                    </VueDatePicker>
                                  </div>

                                </div>
                         
                                  <div style="cursor: pointer; text-decoration: underline; display:Flex;" @click="showHistory = true">

                                    <div style="margin-right:20px;">
                                    
                                    <router-link class="middle" :to="{ name: 'ManagerTasks', params: {}}">Ваши задачи</router-link>
                                    
                                  </div>

                                    Пока вас не было 
                                    <span v-if="monitorHistory">({{ history_count }})</span>
                                    <span v-else>(загрузка...)</span>
                                  </div>
                                </div>
                                <div class="heading">
                                    <div v-if="headDate && headDate.length !== 11">На {{ headDate }}</div>
                                    <div v-else>На {{ date.start }} - {{ date.end }}</div>
                                </div>
                                <div class="my-grid grid-col-4">
                                    <div class="my-grid__item tm-1">
                                        <span class="underline">Заявки</span>
                                        <template v-if="monitor && monitor.monitor && !isLoadingMonitor">
                                          <router-link class="middle" :to="{ name: 'Applications', params: {specialistType, specialist_id, type: 'new'}}">{{ monitor.monitor.request_new }}</router-link>
                                          <router-link class="counter center" :to="{ name: 'Applications', params: {specialistType, specialist_id, type: 'progress'}}">
                                            <span>{{ monitor.monitor.request_progress }} в работе</span>
                                          </router-link>
                                        </template>
                                        <template v-else>
                                          <div class="middle">        <span v-if="isLoadingMonitor">
                                            <v-progress-circular
                                              color="green"
                                              indeterminate
                                              style="width:20px; height:20px;"
                                            ></v-progress-circular>
                                          </span>
                                          <span v-else>0 в работе</span></div>
                                          <div class="counter center">
                                            <span>0 в работе</span>
                                          </div>
                                        </template>
                                    </div>
                                    <div class="my-grid__item tm-1">
                                        <span class="underline">Потенциальные клиенты </span>
                                      <template v-if="monitor && monitor.monitor && !isLoadingMonitor">
                                        <router-link class="middle" :to="{ name: 'PotentialCustomers', params: {specialistType, specialist_id, type: 'active', startdate, enddate}}" >{{ monitor.monitor.clients_active }} ожидают активности</router-link>
                                        <div class="counter">
                                          <span>
                                            <router-link :to="{ name: 'PotentialCustomers', params: {specialistType, specialist_id, type: 'nodeal', startdate, enddate}}"  style="color:#D53025;">
                                              {{ monitor.monitor.clients_nodeals }} без сделок
                                            </router-link>
                                          </span>
                                          <span>
                                            <router-link :to="{ name: 'PotentialCustomers', params: {specialistType, specialist_id, type: 'notask', startdate, enddate}}"  style="color:#D53025;">
                                              {{ monitor.monitor.clients_notasks }} без задач
                                            </router-link>
                                  
                                          </span>
                                        </div>
                                      </template>
                                      <template v-else>
                                        <div class="middle">
                                          <span v-if="isLoadingMonitor">
                                            <v-progress-circular
                                              color="green"
                                              indeterminate
                                              style="width:20px; height:20px;"
                                            ></v-progress-circular>
                                          </span>
                                          <span v-else>0 ожидают активности</span>
                                        </div>
                                        <div class="counter">
                                          <span>0 без сделок</span>
                                          <span>0 без задач</span>
                                        </div>
                                      </template>
                                    </div>
                                    <div class="my-grid__item tm-1">
                                        <span class="underline">Сделки</span>
                                        <template v-if="monitor && monitor.monitor && !isLoadingMonitor">
                                          <router-link class="middle" :to="{ name: 'Transactions', params: {specialistType, specialist_id, type: 'active', startdate, enddate, specialist_ids}}">{{ monitor.monitor.deals_active }} ожидают активности</router-link>
                                          <router-link class="counter center" :to="{ name: 'Transactions', params: {specialistType, specialist_id, type: 'notask', startdate, enddate}}">
                                            <span>{{ monitor.monitor.deals_notasks }} без задач</span>
                                          </router-link>
                                        </template>
                                        <template v-else>
                                          <div class="middle">
                                            <span v-if="isLoadingMonitor">
                                            <v-progress-circular
                                              color="green"
                                              indeterminate
                                              style="width:20px; height:20px;"
                                            ></v-progress-circular>
                                          </span>
                                          <span v-else>0 ожидают активности</span>
                                          </div>
                                          <div class="counter center">
                                            <span>0 без задач</span>
                                          </div>
                                        </template>
                                    </div>
                                    <div class="my-grid__item tm-1">
                                        <span class="underline">Задачи</span>
                                        <template v-if="monitor && monitor.monitor && !isLoadingMonitor">
                                          <router-link class="middle" :to="{ name: 'TasksPage', params: {specialistType, specialist_id, type: 'new', startdate, enddate}}">{{ monitor.monitor.tasks_new }} новых задач</router-link>
                                          <router-link class="counter center" :to="{ name: 'TasksPage', params: {specialistType, specialist_id, type: 'overdue', startdate, enddate}}">
                                            <span>{{ monitor.monitor.tasks_overdue }} просроченных</span>
                                          </router-link>
                                        </template>
                                        <template v-else>
                                          <div class="middle">
                                            <span v-if="isLoadingMonitor">
                                            <v-progress-circular
                                              color="green"
                                              indeterminate
                                              style="width:20px; height:20px;"
                                            ></v-progress-circular>
                                          </span>
                                          <span v-else>0 задач</span>
                                          </div>
                                          <div class="counter center">
                                            <span>0 просроченных</span>
                                          </div>
                                        </template>
                                    </div>
                                </div>
                                <template v-if="monitor">
                                  <div v-for="deal in monitor.monitor.deals" :key="deal.id">
                                    <div class="heading">
                                      {{ deal.name }}
                                    </div>
                                    <div class="my-grid" :style="'grid-template-columns: repeat(' + deal.stages.length + ', 1fr)'">
                                      <div class="my-grid__item tm-2" v-for="stage in deal.stages" :key="stage.id" :style="'border-top-color: ' + stage.colour + ';'">
                                        <span class="top">{{ stage.name }}</span>
                                        <router-link :to="{ name: 'DealsStage', params: {specialist_id, startdate, enddate, type_id: deal.id, stage_id: stage.id, stage_name: stage.name} }" class="counter" style="text-decoration: none">
                                          <span>{{ stage.count }} сделок</span>
                                        </router-link>
                                        <span class="amount">{{ stage.sum }} ₽</span>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                            </Block>
                            <Block :withBorder="true" :padding="0">
                                <div class="heading">
                                    Статистика показателей
                                </div>
                                <div class="my-grid grid-col-3" style="font-size:14px !important;">
                                  <div class="my-grid__item tm-3" style="height: auto;">
                                    <span class="top">Звонки:</span>
                                    <div style="display:flex; width:100%;">
                                      
                                      <div class="statistics" style="width:75%;">
                                        <div class="statistic" style="position: relative; cursor: pointer;" v-for="call in monitor ? monitor.monitor.calls : []" :key="call.user_id" @mouseover="hover = call.user_id" @mouseleave="hover = false">
                                          <v-progress-linear
                                              
                                              class="diagram"
                                              background-color="#FFC83B"
                                              color="#65CBBF"
                                              :value="callCount(call)"
                                          >{{ call.user_name }}</v-progress-linear>
                                          <div class="total" style="display:flex; flex-direction:column;">
                                            <div>{{ +call.call_in + (+call.call_out) }}</div>
                                          </div>

                                          <div class="callHoverDiv" v-if="hover && hover === call.user_id">
                                            <ul>
                                              <li>Входящие: {{ call.call_in }}</li>
                                              <li>Исходящие: {{ call.call_out }}</li>
                                            </ul>
                                          </div>
                                        

                                        </div>
                        
                                      </div>

                                      <div class="types" style="display:flex; flex-direction:column; width:20%; margin-left:10px;">
                                        <div class="call_in">
                                          <div class="point"></div>
                                          <div class="text">Входящие</div>
                                        </div>
                                        <div class="call_out">
                                          <div class="point"></div>
                                          <div class="text">Исходящие</div>
                                        </div>
                                      </div>

                                    </div>


                                  </div>
          
                                  <div class="my-grid__item tm-3" style="height: auto;">
                                    <span class="top">Выполненые задачи:</span>

                                    <div style="display:flex; width:100%;">
                                
                                      <div class="statistics" style="width:70%;">
                                        <div class="statistic" v-for="task in monitor ? monitor.monitor.tasks : []" :key="task.user_id">
                                          <!-- <v-progress-linear
                                              class="diagram"
                                              background-color="#FFC83B"
                                              color="#65CBBF"
                                              :value="taskIn(task)"
                                          >{{ task.user_name }}</v-progress-linear> -->
                                          <div class="statistic" style="display:flex; align-items:center; width:100%; position: relative;">

                                            <div v-for="tasktype in task.type_list" :key="tasktype.id" :style="{ width: (tasktype.count/task.count)*100 + '%' }">
                                              <div :style="{ background: defBgTypes[tasktype.id] }"> 
                                                <span style="color:transparent">{{ tasktype.count }}</span>
                                              </div>
                                            </div>
                                            
                                            <div style="position: absolute; font-size:12px;">{{ task.user_name }}</div>

                                          </div>
                                          
                                          <div class="total">{{ task.count }}</div>
                                        </div>
                                      </div>

                                      <div class="types" style="display:flex; flex-direction:column; align-items:baseline; width:30%;">
                                        <div class="call_in">
                                          <div class="point"></div>
                                          <div class="text">Звонок входящий</div>
                                        </div>
                                        <div class="call_out">
                                          <div class="point"></div>
                                          <div class="text">Звонок исходящий</div>
                                        </div>
                                        <div class="call_meting">
                                          <div class="point"></div>
                                          <div class="text">Встреча</div>
                                        </div>
                                        <div class="call_other">
                                          <div class="point"></div>
                                          <div class="text">Прочее</div>
                                        </div>
                                        <div class="call_guest">
                                          <div class="point"></div>
                                          <div class="text">Гость</div>
                                        </div>
                                        <div class="call_guesting">
                                          <div class="point"></div>
                                          <div class="text">Гостевое посещение</div>
                                        </div>
                                      </div>
                                    </div>


                                  </div>
                                  <div class="my-grid__item tm-3" style="height: auto;">
                                      <span class="top">Продажи и оплаты:</span>
                                    
                                    <div style="display:flex; width:100%;">
                                      <div class="statistics" style="width:88%;">
                                        <div class="statistic" v-for="sale in monitor ? monitor.monitor.sales : []" :key="sale.user_id">
                                          <v-progress-linear
                                              class="diagram"
                                              color="#AEDD7F"
                                              value="100"
                                          >{{ sale.user_name }}</v-progress-linear>
                                          <div class="total">{{ sale.sum_fact }}</div>
                                        </div>
                                      </div>

                                      <div class="types" style="display:flex; flex-direction:column; width:10%; margin-left:10px;">
                                          <div class="facts">
                                            <div class="point"></div>
                                            <div class="text">Факт</div>
                                          </div>
                                      </div>

                                    </div>


                                  </div>
                                </div>
                            </Block>
                        </Grid>
                    </v-container>
                </v-row>
                <v-row justify="center">
              <v-dialog
                  v-model="showHistory"
                  persistent
                  max-width="1000px"
              >
                <v-card rounded="lg">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4>Пока вас не было, с вашими клиентами кто-то поработал</h4>
                    </div>
                    <v-btn icon @click="showHistory = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-data-table
                        v-if="(monitorHistoryDef && monitorHistoryDef.length > 0) || (monitorHistory && monitorHistory.monitor)"
                        :headers="historyHeaders"
                        :items="(monitorHistoryDef && monitorHistoryDef.length > 0) ? monitorHistoryDef : monitorHistory.monitor"
                        no-data-text="Результатов не найдено"
                        :page="page"
                        class="elevation-1"
                    >
                      <template v-slot:item.date="{ item }">
                        <span>{{ item.date ? item.date : 'Нет данных' }}</span>
                      </template>
                      <template v-slot:item.time="{ item }">
                        <span>{{ item.time ? item.time : 'Нет данных' }}</span>
                      </template>
                      <template v-slot:item.user="{ item }">
                       
                        <span>{{ (item.user && item.user.name) ? item.user.name : 'Нет данных' }}</span>

                      </template>
                      <template v-slot:item.object="{ item }">
                        <!-- :to="{ name: 'CardClientNew', params: {client_id: item.object.id}}" -->
                        
                        <!-- <router-link
                            @click="setHistory(item)"
                           
                            class="d-flex"
                            style="align-items: center; text-decoration: none; color: #000"
                        >
                        

                        </router-link> -->

                        <div @click="setHistory(item)" style="align-items: center; text-decoration: none; color: #000"><span style="cursor:pointer; color:blue;">{{ (item.object && item.object.name) ? item.object.name : 'Нет данных' }}</span></div>
                      </template>
                      <template v-slot:item.comment="{ item }">
                        <div v-html="item.comment ? item.comment : 'Нет данных'"></div>
                      </template>
                    <!--                 
                      <template v-slot:item.donedate="{ item }">
                        {{ item.donedate ? formatDate(item.donedate) : null }}
                      </template> -->
                    </v-data-table>

                    <div v-else> Данные в процессе загрузки...</div>

                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import Header from "@/components/Header";
import Menu from "@/components/Menu";
import { VueDatePicker } from '@mathieustan/vue-datepicker';
import {monitorActionTypes} from "@/store/modules/monitor";
import {lessonActionTypes} from "@/store/modules/lesson";
import {mapState} from "vuex";
import {getItem, setItem} from "@/helpers/persistanceStorage";

export default {
    name: "SalesMonitor",
    components: {
        VueDatePicker,
        Header,
        Menu
    },
    data() {
        return {
            dateType: 0,
            specialistType: 1,
            date: (getItem('sales-monitor-datetype_date') && getItem('sales-monitor-datetype_date') !== null && getItem('sales-monitor-datetype_date') !== 'null' && getItem('sales-monitor-datetype_date') !== undefined) ? JSON.parse(getItem('sales-monitor-datetype_date')) : new Date(),
            //date:null,
            dialogDate: false,
            headDate: 'сегодня',
            startdate: new Date(),
            enddate: new Date(),
            structural: null,
            employee: null,
            specialist_id: getItem('sales-monitor-specialist_id') ?? getItem('user_id_1c'),
            specialist_ids: getItem('sales-monitor-specialist_id') ?? getItem('user_id_1c'),
            showHistory:false,
            history_count:0,
            historyHeaders:[
            {text: 'Дата', align: 'start', value: 'date'},
            {text: 'Время', align: 'start', value: 'time'},
            {text: 'Сотрудник', align: 'start', value: 'user.name'},
            {text: 'Клиент', align: 'start', value: 'object'},
            {text: 'Комментарий', value: 'comment'}
            ],
            page: 1,
            hover:false,
            defBgTypes:{
              "0055a2ca-5917-11e8-814d-9c5c8e747603":"#65CBBF",
              "0055a2cb-5917-11e8-814d-9c5c8e747603":"#FFC83B",
              "0055a2c8-5917-11e8-814d-9c5c8e747603":"#4CC366",
              "0055a2ce-5917-11e8-814d-9c5c8e747603":"#E14747"
            },
            monitorHistoryDef:[]
        }
    },
    computed: {
      ...mapState({
        isLoadingMonitor: state => state.monitor.isLoading,
        monitor: state => state.monitor.monitorInfo,
        specialist: state => state.lesson.specialist,
        validationErrors: state => state.monitor.validationErrors,
        monitorHistory: state => state.monitor.monitorHistory,
      })
    },
    methods: {
      setHistory(item){
        if(this.monitorHistoryDef && this.monitorHistoryDef.length > 0){
          console.log('sethistory')
          setItem('sales-monitor-history', JSON.stringify(this.monitorHistoryDef));
          this.$router.push({ name: 'CardClientNew', params: { client_id: item.object.id } })
        }
      },
      setDateType(type){
        setItem('sales-monitor-datetype', type);

            console.log(this.specialistType)

            let spec = (this.specialist_id && this.specialist_id !== 'null' && this.specialist_id !== null) ? this.specialist_id : getItem('user_id_1c')

            if(this.specialistType === 0){
              spec = null
            }

            if (type === 0) {

              console.log('aaaa2')

              this.dialogDate = false;
              this.headDate = 'сегодня';
              this.startdate = new Date();
              this.enddate = new Date();

              this.startdate.setUTCHours(0, 0, 0, 0);
              this.enddate.setUTCHours(23, 59, 0, 0);

              this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
                type: this.specialistType,
                specialist_id: spec,
                startdate: this.startdate,
                enddate: this.enddate
              })
            }
            if (type === 1) {
              this.dialogDate = false;
              this.headDate = 'неделю';

              this.date = new Date()

              this.startdate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() - this.date.getDay() + 2);
              this.enddate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() + (7 - this.date.getDay() + 1))

              this.startdate.setUTCHours(0, 0, 0, 0);
              this.enddate.setUTCHours(23, 59, 0, 0);

              this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
                type: this.specialistType,
                specialist_id: spec,
                startdate: this.startdate,
                enddate: this.enddate
              })
            }
            if (type === 2) {
              this.dialogDate = false;
              this.headDate = 'месяц';

              this.date = new Date()

              this.startdate = new Date(this.date.getFullYear(), this.date.getMonth(), 2);
              this.enddate = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);

              this.startdate.setUTCHours(0, 0, 0, 0);
              this.enddate.setUTCHours(23, 59, 0, 0);

              console.log(this.startdate)

              this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
                type: this.specialistType,
                specialist_id: spec,
                startdate: this.startdate,
                enddate: this.enddate,
                aaaa:1
              })
            }
            if (type === 3) {

              console.log('ssssssssssssssssssssssssssssssss')
              this.date = new Date()
              let day = this.date.getDate() < 10 ? '0' + this.date.getDate() : this.date.getDate();
              let month = (this.date.getMonth() + 1) < 10 ? '0' + (this.date.getMonth() + 1) : (this.date.getMonth() + 1);
              this.headDate = day + '.' + month + '.' + this.date.getFullYear();
              this.dialogDate = true;
            }
      },
      setSpecialistTypeChange(){
        let spec = (this.specialist_id && this.specialist_id !== 'null' && this.specialist_id !== null) ? this.specialist_id : getItem('user_id_1c')

        setItem('sales-monitor-specialist_id', spec);

        if (this.dateType === 0) {


            this.dialogDate = false;
            this.headDate = 'сегодня';
            this.startdate = new Date();
            this.enddate = new Date();
            this.startdate.setUTCHours(0, 0, 0, 0);
              this.enddate.setUTCHours(23, 59, 0, 0);

            this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
              type: this.specialistType,
              specialist_id: spec,
              startdate: this.startdate,
              enddate: this.enddate
            })
            }
            if (this.dateType === 1) {
            this.dialogDate = false;
            this.headDate = 'неделю';

            this.date = new Date()

            this.startdate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() - this.date.getDay() + 2);
            this.enddate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() + (7 - this.date.getDay() + 1))

            this.startdate.setUTCHours(0, 0, 0, 0);
              this.enddate.setUTCHours(23, 59, 0, 0);

            this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
              type: this.specialistType,
              specialist_id: spec,
              startdate: this.startdate,
              enddate: this.enddate
            })
            }
            if (this.dateType === 2) {
            this.dialogDate = false;
            this.headDate = 'месяц';

            this.date = new Date()

            this.startdate = new Date(this.date.getFullYear(), this.date.getMonth(), 2);
            this.enddate = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);

            this.startdate.setUTCHours(0, 0, 0, 0);
              this.enddate.setUTCHours(23, 59, 0, 0);

            this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
              type: this.specialistType,
              specialist_id: spec,
              startdate: this.startdate,
              enddate: this.enddate
            })
            }
            if (this.dateType === 3) {
            this.date = new Date()
            let day = this.date.getDate() < 10 ? '0' + this.date.getDate() : this.date.getDate();
            let month = (this.date.getMonth() + 1) < 10 ? '0' + (this.date.getMonth() + 1) : (this.date.getMonth() + 1);
            this.headDate = day + '.' + month + '.' + this.date.getFullYear();
            this.dialogDate = true;
            }

      },
      setSpecialistType(type){

        console.log("SETSPECIALIST")

        let spec = getItem('user_id_1c')

        if(type) {
          console.log(this.specialist_id)
          console.log('uda1')
          this.specialistType = 1
          this.specialist_id = spec
          setItem('sales-monitor-specialist_id', spec);
        } else {
          console.log('uda2')
          spec = null
          this.specialistType = 0
          this.specialist_id = null
          setItem('sales-monitor-specialist_id', null);

        }

      

      if(getItem('sales-monitor-datetype') && +getItem('sales-monitor-datetype') === 1){
        console.log(getItem('sales-monitor-datetype'))
        this.dateType = 1
      }
      if(getItem('sales-monitor-datetype') && +getItem('sales-monitor-datetype') === 2){
        console.log(getItem('sales-monitor-datetype'))
        this.dateType = 2
      }
      if(getItem('sales-monitor-datetype') && +getItem('sales-monitor-datetype') === 3){
        console.log(getItem('sales-monitor-datetype'))
        this.dateType = 3
        if(getItem('sales-monitor-datetype_date')){
          console.log(getItem('sales-monitor-datetype_date'))
          this.date = JSON.parse(getItem('sales-monitor-datetype_date'))
        }
      }

            if (this.dateType === 0) {


            this.dialogDate = false;
            this.headDate = 'сегодня';
            this.startdate = new Date();
            this.enddate = new Date();

            this.startdate.setUTCHours(0, 0, 0, 0);
              this.enddate.setUTCHours(23, 59, 0, 0);
              
            this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
              type: this.specialistType,
              specialist_id: spec,
              startdate: this.startdate,
              enddate: this.enddate
            })
            }
            if (this.dateType === 1) {
            this.dialogDate = false;
            this.headDate = 'неделю';

            this.date = new Date()

            console.log(this.date.getDay())

            console.log(this.date.getDate())

            this.startdate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() - this.date.getDay() + 2);
            this.enddate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() + (7 - this.date.getDay() + 1))

            this.startdate.setUTCHours(0, 0, 0, 0);
              this.enddate.setUTCHours(23, 59, 0, 0);

            this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
              type: this.specialistType,
              specialist_id: spec,
              startdate: this.startdate,
              enddate: this.enddate
            })
            }
            if (this.dateType === 2) {
            this.dialogDate = false;
            this.headDate = 'месяц';

            this.date = new Date()

            console.log(this.date.getMonth())

            this.startdate = new Date(this.date.getFullYear(), this.date.getMonth(), 2);
            this.enddate = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 1);

            this.startdate.setUTCHours(0, 0, 0, 0);
              this.enddate.setUTCHours(23, 59, 0, 0);

            this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
              type: this.specialistType,
              specialist_id: spec,
              startdate: this.startdate,
              enddate: this.enddate
            })
            }
            if (this.dateType === 3) {

              if(getItem('sales-monitor-datetype_date') && getItem('sales-monitor-datetype_date') !== null && getItem('sales-monitor-datetype_date') !== undefined){
                let praserd = JSON.parse(getItem('sales-monitor-datetype_date'))
                if(praserd && praserd.start){
                  console.log(praserd)
                  this.date = JSON.parse(getItem('sales-monitor-datetype_date'))
                //   let day = this.date.getDate() < 10 ? '0' + this.date.getDate() : this.date.getDate();
                // let month = (this.date.getMonth() + 1) < 10 ? '0' + (this.date.getMonth() + 1) : (this.date.getMonth() + 1);
                // this.headDate = day + '.' + month + '.' + this.date.getFullYear();
                this.dialogDate = true;
                  //this.date = new Date(praserd)
                } else {
                  console.log('ssssssssssssssssssssssssssssssss11111111222')
                this.date = new Date()
                  let day = this.date.getDate() < 10 ? '0' + this.date.getDate() : this.date.getDate();
                let month = (this.date.getMonth() + 1) < 10 ? '0' + (this.date.getMonth() + 1) : (this.date.getMonth() + 1);
                this.headDate = day + '.' + month + '.' + this.date.getFullYear();
                this.dialogDate = true;
                }
                
      
              } else {
                console.log('ssssssssssssssssssssssssssssssss11111111')
                this.date = new Date()
                let day = this.date.getDate() < 10 ? '0' + this.date.getDate() : this.date.getDate();
                let month = (this.date.getMonth() + 1) < 10 ? '0' + (this.date.getMonth() + 1) : (this.date.getMonth() + 1);
                this.headDate = day + '.' + month + '.' + this.date.getFullYear();
                this.dialogDate = true;
              }
        
            }

      },
      getStatWidth(task,cc){
        let taskTypesCount = 0
        let taskTypesItemCount = 0
        
        for(let i = 0; i < task.type_list; i++){
          taskTypesCount = taskTypesCount + task.type_list[i].count
        }

        console.log(cc)
        console.log(taskTypesCount)

        return (cc/taskTypesCount)*100
      },
      fetchFeed() {
        console.log(getItem('sales-monitor-specialist_id'))
        console.log(getItem('user_id_1c'))
        this.specialist_id = (getItem('sales-monitor-specialist_id') && getItem('sales-monitor-specialist_id').length > 10) ? getItem('sales-monitor-specialist_id') : getItem('user_id_1c')
        setItem('sales-monitor-specialist_id', this.specialist_id);
        this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
          type: 1,
          specialist_id: this.specialist_id,
          startdate: this.startdate,
          enddate: this.enddate
        })
        this.$store.dispatch(lessonActionTypes.getSpecialistList);
        this.$store.dispatch(monitorActionTypes.getMonitorHistory).then((response) =>{
          if(response){
            this.history_count = response.monitor.length;
            this.monitorHistoryDef = response.monitor
          }
        });
      },
      taskIn(task) {
        for (let type of task.type_list) {
          if (type.name === 'Звонок входящий')
            return (type.count * 100) / task.count;
        }
        return 0;
      },
      callCount(call) {
        // for (let type of task.type_list) {
        //   if (type.name === 'Звонок входящий')
        //     return (type.count * 100) / task.count;
        // }
        return (+call.call_in*100) / (+call.call_in+(+call.call_out));
      }
    },

    mounted() {
      // this.date = new Date()
      // this.date.start = new Date()
      // this.date.end = new Date()


      
      if(getItem('sales-monitor-specialist_id') && (getItem('sales-monitor-specialist_id').length > 10) && (getItem('sales-monitor-specialist_id') !== getItem('user_id_1c'))){
        this.specialistType = 2
        console.log(getItem('sales-monitor-specialist_id'))
        this.setSpecialistTypeChange()
      } else if(getItem('sales-monitor-specialist_type') !== 'null' && getItem('sales-monitor-specialist_type') !== null && +getItem('sales-monitor-specialist_type') === 0){
        this.specialistType = 0
        this.setSpecialistType(this.specialistType)
      } else if(getItem('sales-monitor-specialist_type') && getItem('sales-monitor-specialist_type') !== 'null' && getItem('sales-monitor-specialist_type') !== null && +getItem('sales-monitor-specialist_type') === 1){
        this.specialistType = 1
        this.setSpecialistType(this.specialistType)
      } else if(getItem('sales-monitor-specialist_type') && getItem('sales-monitor-specialist_type') !== 'null' && getItem('sales-monitor-specialist_type') !== null && +getItem('sales-monitor-specialist_type') === 2){
        this.specialistType = 2
        this.setSpecialistTypeChange()
      } else {


        if(getItem('sales-monitor-datetype') && +getItem('sales-monitor-datetype') === 1){
          console.log(getItem('sales-monitor-datetype'))
          this.dateType = 1
          this.setDateType(1)
        } else if(getItem('sales-monitor-datetype') && +getItem('sales-monitor-datetype') === 2){
          console.log(getItem('sales-monitor-datetype'))
          this.dateType = 2
          this.setDateType(2)
        } else if(getItem('sales-monitor-datetype') && +getItem('sales-monitor-datetype') === 3){
          console.log(getItem('sales-monitor-datetype'))
          this.dateType = 3
          this.setDateType(3)
          console.log(getItem('sales-monitor-datetype_date'))
          if(getItem('sales-monitor-datetype_date') && getItem('sales-monitor-datetype_date') !== null && getItem('sales-monitor-datetype_date') !== undefined){
            this.date = JSON.parse(getItem('sales-monitor-datetype_date'))
          }
        } else {
          this.fetchFeed()
        }
        
      }

      // if(getItem('sales-monitor-datetype') && +getItem('sales-monitor-datetype') === 1){
      //   console.log(getItem('sales-monitor-datetype'))
      //   this.dateType = 1
      // }
      // if(getItem('sales-monitor-datetype') && +getItem('sales-monitor-datetype') === 2){
      //   console.log(getItem('sales-monitor-datetype'))
      //   this.dateType = 2
      // }
      // if(getItem('sales-monitor-datetype') && +getItem('sales-monitor-datetype') === 3){
      //   console.log(getItem('sales-monitor-datetype'))
      //   this.dateType = 3
      //   if(getItem('sales-monitor-datetype_date')){
      //     this.date = getItem('sales-monitor-datetype_date')
      //   }
      // }

      //this.fetchFeed()

      console.log(getItem('sales-monitor-history'))
      if(getItem('sales-monitor-history') && getItem('sales-monitor-history') !== null && getItem('sales-monitor-history') !== 'null' && getItem('sales-monitor-history') !== undefined){
        this.monitorHistoryDef = JSON.parse(getItem('sales-monitor-history'))
        this.showHistory = true
        setItem('sales-monitor-history',null)
      }


      setItem('report_12',null);
    setItem('report_13',null);
    setItem('report_14',null);
    setItem('report_15',null);
    setItem('report_16',null);
    setItem('report_17',null);
    
    setItem('report_newclient_id',null);

    setItem('ext-specialist_id', null);
    setItem('ext-specialist_type', null);
    setItem('ext-datetype', null);
    setItem('ext-datetype_date', null);

    setItem('sale-client',null)
    setItem('customers-specialist_id', null)
    setItem('tasks-specialist_id', null)
    setItem('transactions-specialist_id', null)
    setItem('deals-specialist_id', null)

    setItem('deals-filter_obj', null)
    setItem('task-filter_obj', null)
    setItem('customers-filter_obj', null)
    setItem('transactions-filter_obj', null)

    console.log(this.specialist)

    if(!this.specialist || this.specialist === null || this.specialist === undefined){
      this.$store.dispatch(lessonActionTypes.getSpecialistList);
    }

    },
    watch: {
      specialist_id() {
        // if (this.specialist_id !== null) {
        //   this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
        //     type: this.specialistType,
        //     specialist_id: this.specialist_id,
        //     startdate: this.startdate,
        //     enddate: this.enddate
        //   });
        //   setItem('sales-monitor-specialist_id', this.specialist_id);
          
        // }
      },
      specialistType() {
        console.log('spec_type')
        console.log(this.specialistType)
        setItem('sales-monitor-specialist_type', this.specialistType)


        // if (this.specialistType === 0) {
        //   setItem('sales-monitor-specialist_id', null);

        //   //check dated

        //   if(+getItem('sales-monitor-datetype') === 0){
        //     console.log(getItem('sales-monitor-datetype'))
        //     this.dateType = 0

        //     this.dialogDate = false;
        //     this.headDate = 'сегодня';
        //     this.startdate = new Date();
        //     this.enddate = new Date();

        //     this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
        //       type: this.specialistType,
        //       specialist_id: null,
        //       startdate: this.startdate,
        //       enddate: this.enddate
        //     });
        //   }

        //   if(getItem('sales-monitor-datetype') && +getItem('sales-monitor-datetype') === 1){
        //     console.log(getItem('sales-monitor-datetype'))
        //     this.dateType = 1

        //     this.dialogDate = false;
        //     this.headDate = 'неделю';

        //     this.date = new Date()

        //     this.startdate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() - this.date.getDay() + 1);
        //     this.enddate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() + (6 - this.date.getDay() + 1))

        //     this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
        //       type: this.specialistType,
        //       specialist_id: null,
        //       startdate: this.startdate,
        //       enddate: this.enddate
        //     });


        //   }
        //   if(getItem('sales-monitor-datetype') && +getItem('sales-monitor-datetype') === 2){
        //     console.log(getItem('sales-monitor-datetype'))
        //     this.dateType = 2

        //     this.dialogDate = false;
        //     this.headDate = 'месяц';

        //     this.date = new Date()

        //     this.startdate = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
        //     this.enddate = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);

        //     this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
        //       type: this.specialistType,
        //       specialist_id: null,
        //       startdate: this.startdate,
        //       enddate: this.enddate
        //     });


        //   }
        //   if(getItem('sales-monitor-datetype') && +getItem('sales-monitor-datetype') === 3){
        //     console.log(getItem('sales-monitor-datetype'))
        //     this.dateType = 3
        //     if(getItem('sales-monitor-datetype_date')){
        //       this.date = getItem('sales-monitor-datetype_date')
        //     }
        //   }

      



        // }
        // if (this.specialistType === 1) {
        //   setItem('sales-monitor-specialist_id', getItem('user_id_1c'));
        //   this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
        //     type: this.specialistType,
        //     specialist_id: getItem('user_id_1c'),
        //     startdate: this.startdate,
        //     enddate: this.enddate
        //   });
        // }
        // if (this.specialistType === 2) {
        //   this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
        //     type: this.specialistType,
        //     specialist_id: this.specialist_id,
        //     startdate: this.startdate,
        //     enddate: this.enddate
        //   });
        // }
      },
      dateType() {
      console.log(this.dateType)

       console.log(this.date)

       return;

      
        setItem('sales-monitor-datetype', this.dateType);

        console.log(this.specialistType)
        
        let spec = (this.specialist_id && this.specialist_id !== 'null' && this.specialist_id !== null) ? this.specialist_id : getItem('user_id_1c')

        if(this.specialistType === 0){
          spec = null
        }


        if (this.dateType === 0) {

          console.log('aaaa2')

          this.dialogDate = false;
          this.headDate = 'сегодня';
          this.startdate = new Date();
          this.enddate = new Date();
          this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
            type: this.specialistType,
            specialist_id: spec,
            startdate: this.startdate,
            enddate: this.enddate
          })
        }
        if (this.dateType === 1) {
          this.dialogDate = false;
          this.headDate = 'неделю';

          this.date = new Date()

          this.startdate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() - this.date.getDay() + 1);
          this.enddate = new Date(this.date.getFullYear(), this.date.getMonth(), this.date.getDate() + (6 - this.date.getDay() + 1))
          this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
            type: this.specialistType,
            specialist_id: spec,
            startdate: this.startdate,
            enddate: this.enddate
          })
        }
        if (this.dateType === 2) {
          this.dialogDate = false;
          this.headDate = 'месяц';

          this.date = new Date()

          this.startdate = new Date(this.date.getFullYear(), this.date.getMonth(), 1);
          this.enddate = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0);
          this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
            type: this.specialistType,
            specialist_id: spec,
            startdate: this.startdate,
            enddate: this.enddate
          })
        }
        if (this.dateType === 3) {
          this.date = new Date()
          let day = this.date.getDate() < 10 ? '0' + this.date.getDate() : this.date.getDate();
          let month = (this.date.getMonth() + 1) < 10 ? '0' + (this.date.getMonth() + 1) : (this.date.getMonth() + 1);
          this.headDate = day + '.' + month + '.' + this.date.getFullYear();
          this.dialogDate = true;
        }
      },
      date() {


        let spec = (this.specialist_id && this.specialist_id !== 'null' && this.specialist_id !== null) ? this.specialist_id : getItem('user_id_1c')

        if(this.specialistType === 0){
          spec = null
        }

        if (this.dateType === 3) {
          // if(getItem('sales-monitor-datetype_date')){
          //   this.date = getItem('sales-monitor-datetype_date')
          // } else {
          //   setItem('sales-monitor-datetype_date', this.date);
          // }
          
          setItem('sales-monitor-datetype_date', JSON.stringify(this.date));

          console.log('aaaa1')

          this.startdate = this.date.start
          this.enddate = this.date.end
          
          this.$store.dispatch(monitorActionTypes.getMonitorInfo, {
            type: this.specialistType,
            specialist_id: spec,
            startdate: this.date,
            enddate: this.date
          })
          if (this.dateType === 3) {
            let obj = new Date(this.date)
            let day = obj.getDate() < 10 ? '0' + obj.getDate() : obj.getDate();
            let month = (obj.getMonth() + 1) < 10 ? '0' + (obj.getMonth() + 1) : (obj.getMonth() + 1);
            this.headDate = day + '.' + month + '.' + obj.getFullYear();
          }
        }
      }
    }
}
</script>

<style scoped lang="scss">
.page-top {
    align-items: center;
    margin-bottom: 20px;

    .btn-green {
        background: #629F33;
        border-radius: 12px;
        padding: 7px 20px;
        color: #FFFFFF;
        font-family: 'Circe';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        text-transform: none;
        box-shadow: 0;
    }
}

.filter {
    padding: 20px;
    display: flex;
    align-items: center;

    &__field {
        &:not(:last-child) {
            margin-right: 20px;
        }
    }
}

.heading {
    background: #F1F1F1;
    border-top: 1px solid #E0E0E0;
    border-bottom: 1px solid #E0E0E0;
    padding: 10px 20px;
    text-transform: uppercase;
    color: #000000;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 700;
    font-size: 13px;
    line-height: 16px;
}

.my-grid {
    display: grid;

    &.grid-col-4 {
        grid-template-columns: repeat(4, 1fr);
    }

    &.grid-col-7 {
        grid-template-columns: repeat(7, 1fr);
    }

    &.grid-col-3 {
        grid-template-columns: repeat(3, 1fr);
    }

    &__item {
        border-top: 5px solid #F1F1F1;
        display: flex;
        align-items: center;
        // justify-content: center;
        flex-direction: column;



        &:not(:last-child) {
            border-right: 1px solid #E0E0E0;
        }

        &.tm-1 {
            padding: 15px 20px;

            .underline {
                color: #1A1A1A;
                text-decoration: underline;
                font-family: 'Circe';
                font-style: normal;
                font-weight: 400;
                font-size: 13px;
                line-height: 16px;
            }

            .middle {
                color: #767676;
                font-family: 'Circe';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
                margin: 20px 0;
                text-decoration: none;
            }

            .counter {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;

                &.center {
                    justify-content: center;
                }

                span {
                    color: #D53025;
                    font-family: 'Circe';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 13px;
                    line-height: 16px;
                    text-decoration: underline;
                }
            }
        }

        &.tm-2 {
            padding: 20px 4px;

            &.border-yellow {
                border-top-color: #FBD500;
            }
            &.border-pink {
                border-top-color: #F884A1;
            }
            &.border-dark-blue {
                border-top-color: #0070D2;
            }

            &.border-blue {
                border-top-color: #1BA7DE;
            }

            &.border-light-green {
                border-top-color: #A7E200;
            }

            &.border-green {
                border-top-color: #629F33;
            }

            &.border-red {
                border-top-color: #D53025;
            }

            .top {
                color: #1A1A1A;
                font-family: 'Circe';
                font-style: normal;
                font-weight: 400;
                font-size: 13px;
                line-height: 16px;
                text-align: center;
                flex: 1;
            }

            .counter {
                margin: 20px 0;
                color: #1A1A1A;
                font-family: 'Circe';
                font-style: normal;
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
            }

            .price {
                color: #767676;
                font-family: 'Circe';
                font-style: normal;
                font-weight: 400;
                font-size: 13px;
                line-height: 16px;
            }
        }

        &.tm-3 {
            align-items: flex-start;
            height: 322px;
            border-top: 0;

            .top {
                padding: 19px 20px;
                color: #1A1A1A;
                font-family: 'Circe';
                font-style: normal;
                font-weight: 400;
                font-size: 13px;
                line-height: 16px;
            }
            .types {
              padding: 0 20px;
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              .call_in {
                display: flex;
                align-items: center;
                margin-right: 5px;
                margin-bottom:10px;
                .point {
                  width: 16px;
                  height: 16px;
                  background: #65CBBF;
                }
                .text {
                  font-weight: 400;
                  font-size: 13px;
                  line-height: 16px;
                  color: #1A1A1A;
                }
              }
              .call_out {
                display: flex;
                align-items: center;
                margin-left: 5px;
                margin-bottom:10px;
                .point {
                  width: 16px;
                  height: 16px;
                  background: #FFC83B;
                }
                .text {
                  font-weight: 400;
                  font-size: 13px;
                  line-height: 16px;
                  color: #1A1A1A;
                }
              }
              .call_meting {
                display: flex;
                align-items: center;
                margin-left: 5px;
                margin-bottom:10px;
                .point {
                  width: 16px;
                  height: 16px;
                  background: #4CC366;
                }
                .text {
                  font-weight: 400;
                  font-size: 13px;
                  line-height: 16px;
                  color: #1A1A1A;
                }
              }
              .call_other {
                display: flex;
                align-items: center;
                margin-left: 5px;
                margin-bottom:10px;
                .point {
                  width: 16px;
                  height: 16px;
                  background: #E14747;
                }
                .text {
                  font-weight: 400;
                  font-size: 13px;
                  line-height: 16px;
                  color: #1A1A1A;
                }
              }
              .call_guest {
                display: flex;
                align-items: center;
                margin-left: 5px;
                margin-bottom:10px;
                .point {
                  width: 16px;
                  height: 16px;
                  background: #595959;
                }
                .text {
                  font-weight: 400;
                  font-size: 13px;
                  line-height: 16px;
                  color: #1A1A1A;
                }
              }
              .call_guesting {
                display: flex;
                align-items: center;
                margin-left: 5px;
                .point {
                  width: 16px;
                  height: 16px;
                  background: #003EB3;
                }
                .text {
                  font-weight: 400;
                  font-size: 13px;
                  line-height: 16px;
                  color: #1A1A1A;
                }
              }
              .facts {
                display: flex;
                align-items: center;
                .point {
                  width: 16px;
                  height: 16px;
                  background: #AEDD7F;
                }
                .text {
                  font-weight: 400;
                  font-size: 13px;
                  line-height: 16px;
                  color: #1A1A1A;
                }
              }
            }
            .statistics {
              width: 100%;
              .statistic {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 36px;
                margin: 10px 0;
                padding: 0 20px;
                background-color: #F1F1F1;
                .diagram {
                  text-align: left !important;
                  height: 28px !important;
                  border-radius: 6px !important;
                  width: 85% !important;
                  .v-progress-linear__content {
                    justify-content: start!important;
                    left: 10px !important;
                  }
                }
                .total {
                  width: 10%;
                }
              }
            }
        }
    }
}

.filter-date {
    width: 373px;

    .v-btn-toggle {
        margin: 0 !important;

        button {
            background: #fff !important;
            font-family: 'Circe';
            font-style: normal;
            font-weight: 700;
            font-size: 16px;
            line-height: 24px;
            text-transform: none;

            &.v-btn--active {
                &:before {
                    display: none;
                }
            }
        }
    }
}

.custom__button {
  width: 180px;
  height: 23px;
  display: flex;
  padding: 7px;
  max-width: 180px;
  position: relative;
  box-sizing: content-box;
  align-items: center;
  flex-shrink: 0;
  margin-right: 0;
  border-radius: 12px;
  margin-bottom: 0;
  justify-content: center;
  background-color: var(--dl-color-default-primarysuccess) !important;
  font-size: 16px;
  line-height: 24px;
  color: #fff!important;
}

.callHoverDiv {
  position: absolute;
  width: 200px;
  height: auto;
  transition: 0.5s;
  background: white;
  padding: 10px;
  right:0px;
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}

</style>